<template>
  <div class="modal">
    <div class="modal-background"></div>
    <div
      :class="screen === 'mobile' ? 'modal-active modal-width' : ''"
      class="modal-card"
    >
      <header class="modal-card-head pa-0">
        <div class="column is-full-width is-flex is-content-space-between">
          <div class="is-flex align-center gap-05rem">
            <b class="pl-3">{{ $t('Document') }}</b>
            <tool-tip
              text="Attach your valid documents like citizen, CV"
              from="form"
            >
              <div class="pointer" @click="gotoJobseekerFaq('jobseeker')">
                <vue-icon-base
                  height="16"
                  width="16"
                  :path="$options.icons[$kc('uni-info-circle')]"
                >
                </vue-icon-base>
              </div>
            </tool-tip>
          </div>
          <button
            id="btn-close"
            class="delete is-pulled-right"
            aria-label="close"
            @click="closeIt()"
          ></button>
        </div>
      </header>
      <section class="modal-card-body">
        <Document
          v-if="showForm || isEdit"
          :key="componentKey"
          :action-data="actionData"
          :addAnother="addAnother"
          :update="update"
          @create="createSuccess"
          @update="updateSuccess"
          @closeThis="closeIt()"
          @saveAndAddAnother="componentKey = componentKey + 1"
          @error="error"
        ></Document>
        <div v-else class="card-content">
          <div
            class="columns is-multiline py-3 is-flex is-flex-direction-column"
          >
            <p
              v-if="documentErrorMsg.length"
              class="field-error help is-danger"
            >
              {{ $t('Please upload required documents') }}
              <span v-for="(error, i) in documentErrorMsg" :key="i">
                {{ error }}
                <span v-if="i + 1 < documentErrorMsg.length"> {{ ', ' }}</span>
              </span>
            </p>
            <div v-if="userProfile.details.length" class="column is-12 pt-0">
              <div
                v-for="(document, index) in userProfile.details"
                :key="index"
                class="has-margin-bottom-15"
              >
                <div class="columns is-multiline is-mobile is-centered">
                  <div class="column is-6">
                    <div class="columns has-text-left is-vcentered is-mobile">
                      <div class="column is-1 is-size-4">
                        <vue-icon-base
                          height="16"
                          width="16"
                          :path="$options.icons[$kc('uni-file-alt')]"
                        >
                        </vue-icon-base>
                      </div>
                      <div class="column is-narrow">
                        <div
                          class="has-text-weight-medium is-size-6"
                          v-text="document.title || 'N/A'"
                        ></div>
                      </div>
                      <div class="column is-narrow">
                        <span>
                          <a
                            class="has-text-grey"
                            title="Edit"
                            @click="editDocument(index)"
                          >
                            <vue-icon-base
                              height="16"
                              width="16"
                              :path="$options.icons[$kc('uni-edit')]"
                            >
                            </vue-icon-base>
                          </a>
                        </span>
                        <span>
                          <a
                            class="has-text-grey"
                            title="Delete"
                            @click="deleteDocument(index)"
                          >
                            <vue-icon-base
                              height="16"
                              width="16"
                              :path="$options.icons[$kc('uni-trash-alt')]"
                            >
                            </vue-icon-base>
                          </a>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="column is-6"></div>
                  <div
                    class="column is-11 columns is-multiline is-top-paddingless"
                  >
                    <div class="column is-6">
                      <div class="columns has-text-left is-vcentered is-mobile">
                        <div class="column is-1 is-size-4 mr-2">
                          <vue-icon-base
                            height="16"
                            width="16"
                            :path="$options.icons[$kc('uni-list-ui-alt')]"
                          >
                          </vue-icon-base>
                        </div>
                        <div class="column">
                          <div
                            class="has-text-grey is-size-7"
                            v-text="$t('category')"
                          ></div>
                          <div
                            class="has-text-weight-medium is-size-6"
                            v-text="get(document, 'category.name') || 'N/A'"
                          ></div>
                        </div>
                      </div>
                    </div>
                    <div class="column is-6">
                      <div class="columns has-text-left is-vcentered is-mobile">
                        <div class="column is-1 is-size-4 mr-2">
                          <vue-icon-base
                            height="16"
                            width="16"
                            :path="$options.icons[$kc('uni-paperclip')]"
                          >
                          </vue-icon-base>
                        </div>
                        <div class="column">
                          <div
                            class="has-text-grey is-size-7"
                            v-text="$t('Attachment')"
                          ></div>
                          <div class="has-text-weight-medium is-size-6">
                            <a
                              :href="document.attachment"
                              :download="
                                prepareFileName(
                                  document.title,
                                  document.attachment
                                )
                              "
                              target="_blank"
                            >
                              <span>
                                {{
                                  prepareFileName(
                                    document.title,
                                    document.attachment
                                  )
                                }}
                              </span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="column">
              <vue-no-data :loading="loading"></vue-no-data>
            </div>
          </div>
        </div>
        <div v-if="showDeleteModal">
          <vue-delete-modal
            :item-info="userProfile.name"
            @dismissModal="cancel"
            @confirmDelete="deleteInfo"
          ></vue-delete-modal>
        </div>
      </section>
      <footer v-if="!showForm && !isEdit" class="modal-card-foot pa-0">
        <div class="column has-text-right">
          <button
            id="btn-skip-education"
            class="button is-size-6-desktop is-size-7-mobile"
            @click="closeIt"
          >
            {{ $t('Skip') }}
          </button>
          <button
            id="btn-create-document"
            class="button is-success is-size-6-desktop is-size-7-mobile"
            @click="createDocument"
          >
            {{ $t('Create New') }}
          </button>
        </div>
      </footer>
      <footer v-if="showForm || isEdit" class="modal-card-foot pa-0">
        <div class="column has-text-right">
          <button
            id="btn-save-another"
            class="button is-success is-outlined is-white has-text-success has-background-white has-margin-bottom-10-mobile"
            @click="addAnother = !addAnother"
          >
            {{ $t('Save and Add Another') }}
          </button>
          <button
            id="btn-submit-docuemnt"
            class="button is-success"
            :disabled="!!inputError.length"
            @click="update = !update"
          >
            {{ $t('Submit') }}
          </button>
        </div>
      </footer>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import UserProfileMixin from '@/mixins/userProfile'
import VueNoData from '@/components/Commons/VueNoData'
import VueIconBase from '@/components/Commons/VueIconBase'

import {
  uniFileAlt,
  uniEdit,
  uniTrashAlt,
  uniListUiAlt,
  uniPaperclip,
  uniInfoCircle
} from '@/helpers/icons'
import ToolTip from '~/components/ToolTip.vue'
export default {
  icons: {
    uniFileAlt,
    uniEdit,
    uniTrashAlt,
    uniListUiAlt,
    uniPaperclip,
    uniInfoCircle
  },
  components: {
    ToolTip,
    VueIconBase,
    Document: () =>
      import('@/components/Jobseeker/Profile/Document/Forms/Document'),
    VueDeleteModal: () => import('@/components/Commons/VueDeleteModal'),
    VueNoData
  },
  mixins: [UserProfileMixin],
  props: {
    userInfo: {
      type: Object,
      required: true
    },
    isEdit: {
      type: Boolean
    },
    documentErrorMsg: {
      type: Array,
      required: false,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      addAnother: false,
      update: false,
      inputError: '',
      userProfile: {
        pk: 'id',
        name: 'Document Information',
        endpoint: '/api/v1/jobseekers/me/documents/',
        details: [],
        autoFetch: true
      },
      actionData: {},
      showForm: false,
      showDeleteModal: false,
      loading: false,
      showDetails: 0,
      componentKey: 1
    }
  },
  computed: {
    ...mapGetters({ screen: 'getScreen' })
  },
  methods: {
    gotoJobseekerFaq(slug) {
      const url = this.localePath({
        name: 'faq-category-slug',
        params: { slug }
      })
      window.open(url, '_blank')
    },
    error(val) {
      this.inputError = val
    },
    closeIt() {
      this.$emit('closeThis')
    },
    createDocument() {
      this.showForm = true
      this.actionData = {}
    },
    editDocument(index) {
      this.actionData = this.userProfile.details[index]
      this.showForm = true
    },
    deleteDocument(index) {
      this.actionData = this.userProfile.details[index]
      this.showDeleteModal = true
    },
    cancel() {
      if (this.componentKey && this.componentKey !== 1) {
        this.getProfileInfo()
      }
      this.actionData = {}
      this.showForm = false
      this.showDeleteModal = false
    },
    prepareFileName(title, filePath) {
      const path = filePath.slice(0)
      if (title && path) {
        const extensions = path.split('.').pop()
        return `${title}.${extensions}`
      } else return title
    }
  }
}
</script>
